<template>
  <div class="header">
    <div class="pwa-header" v-if="showPwaInstall && pwaShowPwaInstall && !isLandscape">
      <pwa-install-top></pwa-install-top>
      <Icon
        class="pwa-close"
        name="close"
        @click="handleHeaderPwaInstall(false)"
      />
    </div>
    <div class="top-header">
      <div class="switch-version-wrap" v-if="headerShowSwitchVersion">
        <div class="switch-version" @click="switchVersion">
          <em class="switch-icon"></em>
          {{ letter.v3SwitchOldVersion }}
        </div>
      </div>
      <div class="game-info" @click="backToHome">
        <img
          class="game-logo"
          v-if="logo"
          :src="logo"
          alt="game-logo"
          :class="{ large: isJpPlatform }"
        />
        <div class="header-safe">
          <Icon class="header-safe-icon" name="safe" />
          <p class="header-safe-tip">
            {{ letter.officialStore }} <br />
            {{ letter.headerSafeTip }}
          </p>
        </div>
      </div>
      <div class="right-info" :class="{ webviewRight: isInWebview }">
        <div
          class="header-pwa-install"
          v-if="showPwaInstall && pwaShowPwaInstall && isLandscape"
        >
          <pwa-install-top></pwa-install-top>
        </div>
        <div v-if="isJpPlatform" class="jp-info">
          <div class="jp-info-icon"></div>
          <div class="jp-info-name"></div>
        </div>
        <div class="lang-switch j-select-lang">
          <div class="lang-switch-pc flex-center" @click="toggleLangSelecter">
            <Icon class="lang-switch-ico" name="global" />
            <span class="lang-switch-text">{{ langList[lang] }}</span>
            <Icon
              class="lang-switch-right"
              :class="{ active: showLangSelecter }"
              name="down"
            />
          </div>
          <Icon
            class="lang-switch-m lang-switch-ico"
            name="global"
            @click="toggleLangSelecter"
          />
          <lang-selecter
            v-if="showLangSelecter"
            @closeSelecter="showLangSelecter = false"
            :langList="langList"
            :curLang="lang"
            :languages="letter"
            @selectLang="selectLang"
            @hideLangSelecter="showLangSelecter = false"
            style="z-index: 1002"
          ></lang-selecter>
        </div>
        <template v-if="showLogin">
          <div
            v-if="isLogin"
            @click.stop="handleShowAccountSelecter"
            class="user-center-ico-wrap"
          >
            <Icon class="user-center-ico" name="me" />
            <em class="red-dot" v-if="showRedDot">+1</em>
          </div>
          <a
            v-else
            href="javascript:;"
            class="j-login-btn login-btn"
            @click="handleShowLoginPopup"
            >{{ letter.login }}</a
          >
        </template>
      </div>

      <transition name="slide-down">
        <account-selecter
          v-show="showAccountSelecter"
          @hideAccountSelecter="hideAccountSelecterHandle"
        ></account-selecter>
      </transition>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import PwaInstallTop from '@components/officialTopup/pwa/PwaInstallTop.vue';
import LangSelecter from '@components/officialTopup/LangSelecter.vue';
import AccountSelecter from '@components/officialTopup/AccountSelecter.vue';
import { mapGetters, mapState } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import { isSafari } from '@utiles/officialStore/device';
import { LANGUAGE_LOCALSTORGE_NAME } from '@store/languages';
import { SET_PWA_STATUS } from '@store/officialTopup/activity';
import { SET_ACCOUNT_SELECTER_STATUS } from '@store/officialTopup/login';
import {
  SWITCH_LANGUAGE,
  GET_PRODUCT_LIST,
  UPDATE_PRODUCT_LIST,
  UPDATE_PRODUCT_TYPES,
  SET_SHOW_CHANNEL_STATUS,
  UPDATE_LOADING
} from '@store/officialTopup';
import { CLEAR_CART } from '@store/officialTopup/cart';

import {
  locationType,
  clickButton,
  showPopup
} from '@plugins/biPoint/_configWebstoreV3';
import login from '@mixins/officialTopup/login';
import switchVersion from '@mixins/officialTopup/switchVersion';
export default {
  props: {
    showLogin: {
      type: Boolean,
      default: true
    }
  },
  mixins: [login, switchVersion],
  data() {
    return {
      showLangSelecter: false,
      isSafari: isSafari(),
      isHideAdd:
        globalConfig.getHrefParam('cid') === 'shortcut' ||
        globalConfig.getHrefParam('scid').includes('shortcut')||
        globalConfig.getHrefParam('mode').includes('pwa'),
      isLandscape: window.innerWidth > window.innerHeight
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      lang: state => state.lang,
      langList: state => state.langList,
      gameId: state => state.gameId,
      picList: state => state.page.picList,
      showPwaInstall: state => state.activity.showPwaInstall,
      showAccountSelecter: state => state.login.showAccountSelecter,
      isInWebview: state => state.isInWebview,
      gameCouponEnableList: state => state.coupon.gameCouponEnableList,
      isInstall: state => state.page.isInstall.value,
      openPwa: state => state.page.openPwa
    }),
    ...mapGetters(['isJpPlatform']),
    logo() {
      return this.picList?.icon;
    },
    pwaShowPwaInstall() {
      return (
        this.openPwa &&
        !this.isHideAdd && // pwa进入不展示
        (this.isSafari || !this.isInstall) && // 已安装不展示，safari展示
        !this.isJpPlatform // 日本平台不展示
      );
    },
    showRedDot() {
      return this.gameCouponEnableList?.length > 0;
    }
  },
  methods: {
    backToHome() {
      if (this.$route.name === 'home') return;
      this.$router.push({
        name: 'home'
      });
    },
    selectLang(val) {
      this.showLangSelecter = false;
      globalConfig.setLclStorageItem(LANGUAGE_LOCALSTORGE_NAME, val);
      this.$store.dispatch(SWITCH_LANGUAGE, val);
      if (this.$store.state.serverId && this.$store.state.roleId) {
        this.$store.dispatch(GET_PRODUCT_LIST);
        this.$store.commit(UPDATE_PRODUCT_LIST, []);
        this.$store.commit(UPDATE_PRODUCT_TYPES, []);
      }
      this.$store.commit(SET_SHOW_CHANNEL_STATUS, false);
      this.$store.commit(CLEAR_CART);
      window?.globalUpdateCommonParamsInfo?.({
        language: val
      });
      clickButton({
        btnName: 'select_language',
        locationKey: this.$route.meta.pageName
      });
    },
    toggleLangSelecter() {
      clickButton({
        btnName: 'select_language_btn',
        locationKey: this.$route.meta.pageName
      });
      this.showLangSelecter = !this.showLangSelecter;
    },
    handleShowLoginPopup() {
      clickButton({
        btnName: 'go_login',
        locationKey: locationType.accountInfo
      });
      this.showLoginPopup();
    },
    handleHeaderPwaInstall(state) {
      this.$store.commit(SET_PWA_STATUS, state);
    },
    handleShowAccountSelecter() {
      this.$store.commit(
        SET_ACCOUNT_SELECTER_STATUS,
        !this.showAccountSelecter
      );
      clickButton({
        btnName: 'account_info',
        locationKey: this.$route.meta.pageName
      });
      if (this.showAccountSelecter) {
        showPopup(locationType.accountInfoPopup);
      }
    },
    hideAccountSelecterHandle() {
      this.$store.commit(SET_ACCOUNT_SELECTER_STATUS, false);
    }
  },

  components: {
    PwaInstallTop,
    LangSelecter,
    AccountSelecter
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/_dimen.scss';
.header {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
}
.pwa-header {
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 18px 20px;
  background-color: #000000;

  .pwa-close {
    position: absolute;
    right: 50px;
    top: 27px;
    color: #ffffff;
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
}
.top-header {
  display: flex;
  justify-content: space-between;
  height: $headerHeight;
  width: 100%;
  font-size: 20px;
  background-position: center center;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  background-color: rgba(0, 0, 0);
  position: relative;

  .game-info {
    display: flex;
    align-items: center;
    margin-left: 42px;
    .game-logo {
      width: 68px;
      border-radius: 9px;
      cursor: pointer;
      &.large {
        width: 120px;
      }
    }
  }
  .right-info {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    margin-right: 42px;
    &.webviewRight {
      margin-right: 82px;
    }
    .jp-info {
      display: none;
    }
    .login-btn {
      margin-left: 20px;
      background-color: #ffffff;
      color: #000000;
      font-size: 24px;
      padding: 10px 40px;
      border-radius: 40px;
      white-space: nowrap;
    }
    .lang-switch {
      position: relative;
      color: #ffffff;

      &-ico {
        display: inline-block;
        margin-right: 10px;
        width: 44px;
        height: 44px;
      }
      &-right {
        width: 32px;
        height: 32px;

        &.active {
          transform: rotate(180deg);
        }
      }

      .lang-switch-pc {
        display: none;
      }
      .lang-switch-m {
        display: inline-block;
        font-size: 44px;
      }
    }
    .user-center-ico-wrap {
      position: relative;
    }
    .user-center-ico {
      width: 44px;
      height: 44px;
      margin-left: 20px;
      color: $themeColor;
      cursor: pointer;
    }
  }
  .header-pwa-install {
    display: none;
  }
  .header-safe {
    margin-left: 20px;
    padding: 12px 17px 15px;
    background-color: rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    justify-self: center;
    align-items: center;
    display: flex;

    .header-safe-icon {
      width: 40px;
      height: 46px;
      color: $themeColor;
    }
    .header-safe-tip {
      margin-left: 10px;
      font-size: 16px;
      color: #ffffff;
      line-height: 1.5;
    }
  }
  .btn-wrap {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    background: #fff;
    border-radius: 30px;
    padding: 0 20px;
    height: 45px;
    box-sizing: border-box;
    cursor: pointer;
  }
  .red-dot {
    position: absolute;
    right: -7px;
    top: -7px;
    width: 16px;
    height: 16px;
    background-color: #ff2800;
    border-radius: 50%;
    font-size: 12px;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .switch-version-wrap {
    position: absolute;
    top: 120px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 20px;
    width: 100%;
    height: 173px;
    top: 0;
    z-index: -1;
    .switch-version {
      position: absolute;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 186px;
      height: 53px;
      font-size: 18px;
      color: #ffffff;
      cursor: pointer;
      width: 100%;
      .switch-icon {
        display: block;
        width: 29px;
        height: 29px;
        margin-right: 5px;
        background: url($commonImg + 'switch-version.png') no-repeat;
        background-size: cover;
      }
    }
  }
}

@media screen and (orientation: landscape) {
  .pwa-header {
    display: none;
  }
  .top-header {
    .game-info {
      .game-logo {
        width: 68px;
        &.large {
          width: 120px;
        }
      }
    }
    .right-info {
      .jp-info {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 20px;
        margin-right: 80px;
        &-icon {
          width: 70px;
          height: 70px;
          background: url($beautyImg + 'topheader-icon.png') no-repeat
            center/contain;
          border-radius: 10px;
        }
        &-name {
          width: 256px * 0.8;
          height: 107px * 0.8;
          background: url($beautyImg + 'topheader-logo.png') no-repeat
            center/contain;
        }
      }
      .lang-switch {
        &-ico {
          width: 32px;
          height: 32px;
        }
        &-right {
          width: 32px;
          height: 32px;
        }
        .lang-switch-pc {
          display: flex;
          cursor: pointer;

          .lang-switch-text {
            ::v-deep .select {
              padding: 0;
            }
          }
        }
        .lang-switch-m {
          display: none;
        }
      }
      .user-center-ico {
        width: 32px;
        height: 32px;
      }

      .header-pwa-install {
        display: inline-block;
      }
    }
    .switch-version-wrap {
      display: none;
    }
  }
}
</style>
